module.exports = __webpack_public_path__ + "static/media/icon Pause - CBA2A7.2c9b0089.svg";